import { SIGN_UP_FLOW_REVAMP_SEO_MILESTONE_3_231122 } from "@faire/web-api/indigofair/settings/SIGN_UP_FLOW_REVAMP_SEO_MILESTONE_3_231122";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

// This setting is no longer related to SEO only, but controls the whole sign up revamp
export const getSettingSignupRevampSEO = (): boolean =>
  getSettingValueWithoutAssignment(
    SIGN_UP_FLOW_REVAMP_SEO_MILESTONE_3_231122,
    false
  );
